/**
 * Truncates a string in the middle, showing the beginning and end with "..." in between.
 * If the string is shorter than maxLength, it returns the original string unchanged.
 *
 * @param text - The string to truncate
 * @param maxLength - Maximum length of the resulting string (default: 50)
 * @returns The truncated string with ellipsis in the middle, or the original string if it's short enough
 *
 * @example
 * truncateInMiddle("very-long-filename-that-needs-truncation.pdf") // "very-l...ation.pdf"
 * truncateInMiddle("short.pdf", 50) // "short.pdf"
 */
export function truncateInMiddle(text: string, maxLength: number = 50): string {
  if (text.length <= maxLength) {
    return text;
  }
  const halfLength = Math.floor(maxLength / 2);
  const start = text.substring(0, halfLength - 3);
  const end = text.substring(text.length - halfLength);
  return `${start}...${end}`;
}
